import { FC } from 'react';

import { Grid, Typography } from '@mui/material';
import clsx from 'clsx';

import { IInvestmentGridHeaderProps } from './types';
import { columns } from '../../utils/form';
import { columnWidth } from '../constants';

import styles from './InvestmentGridHeader.module.scss';

export const InvestmentGridHeader: FC<IInvestmentGridHeaderProps> = ({ disabled }) => {
  return (
    <Grid container display="flex" alignItems="center" gap={1} className={styles.container}>
      {columns.map((columnTitle, index) => (
        <Grid key={columnTitle} item sx={{ width: columnWidth[index] }}>
          <Typography variant="subtitle2" className={clsx(styles.title, {[styles.disabled]: disabled})}>
            {columnTitle}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};
